import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import TenantUserTypeSelectorDialogMenuItem from "@/v2-backoffice-client/tenant/user/type/TenantUserTypeSelectorDialogMenuItem"
import TenantUserRemoveMenuItem from "@/v2-backoffice-client/tenant/user/remove/TenantUserRemoveMenuItem"
import TenantUserRestoreMenuItem from "@/v2-backoffice-client/tenant/user/restore/TenantUserRestoreMenuItem"
import TenantExternalToolMenuItems from "@/v2-backoffice-client/tenant/TenantExternalToolMenuItems"
import TenantUpdateMenuItem from "@/v2-backoffice-client/tenant/update/TenantUpdateMenuItem"
import TenantCustomerAddSelectorDialogMenuItem from "@/v2-backoffice-client/tenant/customer/add/TenantCustomerAddSelectorDialogMenuItem"
import TenantRemoveMenuItem from "@/v2-backoffice-client/tenant/remove/TenantRemoveMenuItem"
import TenantRestoreMenuItem from "@/v2-backoffice-client/tenant/restore/TenantRestoreMenuItem"

export type UserTenantTableRowToolbarProps = {
  userId: number
  userTenant: UserTenantFragment
  onlyDeleted: boolean
}

function UserTenantTableRowToolbar(props: UserTenantTableRowToolbarProps) {
  const { userId, userTenant, onlyDeleted } = props
  const tenant = userTenant.Tenant

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <TenantUserTypeSelectorDialogMenuItem userTenant={userTenant} />

        {onlyDeleted ? (
          <TenantUserRestoreMenuItem
            tenantId={userTenant.TenantId}
            userId={userId}
          />
        ) : (
          <TenantUserRemoveMenuItem
            tenantId={userTenant.TenantId}
            userId={userId}
          />
        )}

        <ActionMenu.Separator />

        <ActionMenu.Label>Team Actions</ActionMenu.Label>

        <div className="pl-2">
          <TenantExternalToolMenuItems
            tenantId={tenant?.Id}
            externalCustomerId={tenant?.ExternalCustomerId}
            billingAccountUuid={tenant?.BillingAccountUuid}
          />

          <ActionMenu.Separator />

          {tenant && <TenantUpdateMenuItem tenant={tenant} />}
          {tenant && (
            <TenantCustomerAddSelectorDialogMenuItem
              tenantId={tenant.Id}
              tenantName={tenant.Name}
              externalCustomerId={tenant.ExternalCustomerId}
            />
          )}

          <ActionMenu.Separator />

          {tenant &&
            (tenant.IsDeleted ? (
              <TenantRestoreMenuItem tenantId={tenant.Id} />
            ) : (
              <TenantRemoveMenuItem tenantId={tenant.Id} />
            ))}
        </div>
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default UserTenantTableRowToolbar
